// extracted by mini-css-extract-plugin
var _1 = "om1RQgolLGkHkAZW9uex";
var _2 = "om1RQgolLGkHkAZW9uex";
var _3 = "MlQfC3kgVztR8JzLLwkB";
var _4 = "MlQfC3kgVztR8JzLLwkB";
var _5 = "XHVmgCT6QkX2uoKWpkhl";
var _6 = "HSykYf1CU0x6XgnJQ6FM";
export { _1 as "form-bottom-margin", _2 as "formBottomMargin", _3 as "inline-block", _4 as "inlineBlock", _5 as "minimum", _6 as "title" }
